<template>
    <div class="relative flex-grow inline-block w-full md:w-1/2 xl:w-1/3 mb-12 md:mb-20 px-4">
        <div class="w-full cursor-pointer group" @click="makeActive()">
            <div
                class="w-full h-4 mb-8 transition-quad"
                :class="
                    this.$parent.activePanel === this.id
                        ? 'bg-grey group-hover:bg-grey-light'
                        : 'bg-black group-hover:bg-red'
                "
            ></div>
            <div class="flex items-start justify-between">
                <h4
                    class="font-bold text-3xl leading-tight mb-4 transition-quad"
                    :class="this.$parent.activePanel === this.id ? 'text-pink' : 'text-black group-hover:text-red'"
                >
                    <slot name="question"></slot>
                </h4>

                <div
                    class="flex-shrink-0 flex items-center justify-center w-8 h-8 ml-10 border-2 rounded-full transition-quad lg:hidden"
                    :class="
                        this.$parent.activePanel === this.id
                            ? 'border-pink text-pink rotate-180'
                            : 'border-black text-black'
                    "
                >
                    <div class="w-3">
                        <slot name="icon"></slot>
                    </div>
                </div>
            </div>
        </div>

        <transition
            name="accordion"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
        >
            <div class="w-full overflow-hidden transition-circ" v-show="this.$parent.activePanel === this.id">
                <p class="leading-loose">
                    <slot name="answer"></slot>
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['id'],
    methods: {
        makeActive() {
            if (this.$parent.activePanel === this.id) {
                this.$parent.activePanel = null
            } else {
                this.$parent.activePanel = this.id
            }
        },
        beforeEnter(el) {
            el.style.height = '0'
        },
        enter(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        leave(el) {
            el.style.height = '0'
        },
    },
}
</script>
